import AppContext from '../../../lib/app-context/AppContex';
var CmsContext = new AppContext(['footnotes', 'references', 'id', 'templateType']);
export default CmsContext;